import React from 'react';
import ContactHero from '../marketing/components/ContactHero';
import { COMPANY } from '../config/brand';

const Row = ({ label, children }) => (
  <div className="border-b border-line py-4 last:border-0 sm:flex sm:gap-6">
    <dt className="w-40 shrink-0 text-sm font-semibold text-muted">{label}</dt>
    <dd className="mt-1 text-sm text-ink sm:mt-0">{children}</dd>
  </div>
);

// The previous site's enquiry form sent nothing, so there is no form until a
// real one is wired up (weicare open question 2). Email and phone instead.
const Contact = () => (
  <>
    <ContactHero />
    <section className="wc-container py-14">
      <dl className="wc-card mx-auto max-w-2xl px-6">
        <Row label="Email"><a className="text-primary underline" href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a></Row>
        <Row label="Phone"><a className="text-primary underline" href={COMPANY.phoneHref}>{COMPANY.phone}</a></Row>
        <Row label="Location">{COMPANY.location}</Row>
        <Row label="Company">{COMPANY.legalName} · ABN {COMPANY.abn}</Row>
      </dl>
    </section>
  </>
);

export default Contact;
